var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3425 6.09C15.1025 5.6775 14.6825 5.4375 14.21 5.4375H5.12C4.385 5.4375 3.695 5.835 3.3275 6.48L1.8125 9.135V3C1.8125 2.4825 2.2325 2.0625 2.75 2.0625H5.1275C5.375 2.0625 5.615 2.16 5.7875 2.34L6.6275 3.18C6.875 3.4275 7.2125 3.5625 7.5575 3.5625H12.5C12.8075 3.5625 13.0625 3.3075 13.0625 3C13.0625 2.6925 12.8075 2.4375 12.5 2.4375H7.5575C7.505 2.4375 7.46 2.415 7.4225 2.385L6.5825 1.545C6.1925 1.155 5.675 0.9375 5.1275 0.9375H2.75C1.61 0.9375 0.6875 1.86 0.6875 3V11.25C0.6875 11.3475 0.7175 11.43 0.755 11.505C0.755 11.5125 0.755 11.52 0.755 11.535C0.7625 11.55 0.7775 11.5575 0.785 11.565C0.8225 11.6175 0.8675 11.6625 0.92 11.7C0.9425 11.715 0.9575 11.73 0.98 11.7375C1.055 11.775 1.1375 11.805 1.235 11.805H12.05C12.5225 11.805 12.9575 11.55 13.19 11.145L15.335 7.395C15.5675 6.9825 15.5675 6.495 15.335 6.0825L15.3425 6.09ZM14.3675 6.84L12.2225 10.59C12.1925 10.65 12.125 10.6875 12.0575 10.6875H2.2175L4.3025 7.035C4.4675 6.7425 4.7825 6.5625 5.12 6.5625H14.21C14.3075 6.5625 14.3525 6.6225 14.375 6.66C14.3975 6.6975 14.42 6.765 14.375 6.8475L14.3675 6.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessActivity);
export default __webpack_public_path__ + "static/media/process-activity.f9de3b0dc4ec3651771dacea8198810a.svg";
export { ForwardRef as ReactComponent };